var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { formatMicroFrontUrl, formatMicroFrontRouterPath } from "./microFrontUrl";
import Config from "../../config";
function initRouter() {
    function $destination(...args) {
        var _a, _b;
        (_b = (_a = Config.router) === null || _a === void 0 ? void 0 : _a.destination) === null || _b === void 0 ? void 0 : _b.call(this, ...args);
    }
    function $link(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, target = "_self") {
            var _a, _b;
            let realUrl;
            if (typeof url === "function") {
                realUrl = yield url();
            }
            else if ((url === null || url === void 0 ? void 0 : url.charAt(0)) === "/") {
                (_b = (_a = Config.router) === null || _a === void 0 ? void 0 : _a.destination) === null || _b === void 0 ? void 0 : _b.call(this, url, target);
                return;
            }
            else {
                realUrl = url;
            }
            downloadClick(realUrl, target);
        });
    }
    function $toQueryString(params) {
        const query = Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join("&");
        return query.length > 0 ? `?${query}` : "";
    }
    Config.globalProperties.set("$destination", $destination);
    Config.globalProperties.set("$link", $link);
    Config.globalProperties.set("$formatMicroFrontUrl", formatMicroFrontUrl);
    Config.globalProperties.set("$formatMicroFrontRouterPath", formatMicroFrontRouterPath);
    Config.globalProperties.set("$toQueryString", $toQueryString);
    return {
        formatMicroFrontUrl: formatMicroFrontUrl,
        formatMicroFrontRouterPath: formatMicroFrontRouterPath,
        link: $link,
        destination: $destination,
    };
}
function downloadClick(realUrl, target) {
    const a = document.createElement("a");
    a.setAttribute("href", realUrl);
    a.setAttribute("target", target);
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
    }, 500);
}
export { initRouter, downloadClick };
export * from "./microFrontUrl";
